export const getFileNameFromFilePath = (filePath: string): string => {
    const pathParts = filePath.split('/');

    return pathParts.pop() ?? '';
};
